import { object } from 'yup';

const SELECTED_BORROWERS_PREFIX = 'selectedBorrowers';

export const getBorrowerFieldName = index => `${SELECTED_BORROWERS_PREFIX}${index}`;

export const loanDenialFormSchema = object().shape({
  name: object().nullable().required('Denial Reason is required'),
});
